define('SageDotCom/Utility/viewport',[
    "SageDotCom/Utility/consumableArray",
    "SageDotCom/Utility/dimensions",
    "ScrollMagic"
  ],
  function(_toConsumableArray, dimensions, ScrollMagic) {

    var setDurationOfScene = function setDurationOfScene(container) {
      var height = void 0;
      if (container.offsetHeight < dimensions.height) {
        height = container.offsetHeight * 4;
      } else {
        height = container.offsetHeight * 1.6;
      }
      return height;
    };

    var viewportExitStageScene = function viewportExitStageScene(viewport, ctrl) {
      return new ScrollMagic.Scene({
          triggerElement: viewport,
          triggerHook: 0.05
          //   duration: setDurationOfScene(viewport)
        }).setTween(viewport, 0.5, {
          boxShadowColor: 'rgba(0, 25, 36, 0.8)'
        }).reverse(false)
        // .addIndicators({name: viewport.classList+' enter'})
        .addTo(ctrl);
    };

    var viewportEnterStageScene = function viewportEnterStageScene(viewport, ctrl) {
      return new ScrollMagic.Scene({
          triggerElement: viewport,
          triggerHook: 0.7
          // duration: setDurationOfScene(viewport)
        }).setClassToggle(viewport, 'is-active').reverse(false)
        // .addIndicators({name: viewport.classList+' enter'})
        .addTo(ctrl);
    };

    return {
      init: function init(viewports, ctrl) {
        _toConsumableArray = function(arr) {
          if (jQuery.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }
            return arr2;
          } else {
              var converted_array = [];
              var length = arr.length;

              for (var i = 0; i < length; i++) {
                  converted_array.push(arr[i]);
              }

              return converted_array;
          }
        };
        return [].concat(_toConsumableArray(viewports)).map(function(viewport) {
          viewportEnterStageScene(viewport, ctrl);
          viewportExitStageScene(viewport, ctrl);
        });
      }
    };
  });

